import * as React from 'react'

function SvgWeight(props) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M5 5v14h2v-6h10v6h2V5h-2v6H7V5H5zM2 7v4H0v2h2v4h2V7H2zm18 0v10h2v-4h2v-2h-2V7h-2z"
        fill="currentColor"
      />
    </svg>
  )
}

export default SvgWeight
